<template>
  <crud-delete :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @delete="remove"
               @close="$emit('close')"
  >
    <cash-register-show-data :item="item" />
  </crud-delete>
</template>

<script>
import CashRegisterProvider from "../../../../providers/CashRegisterProvider";
import {CrudDelete, ClientError} from '@dracul/common-frontend'
import CashRegisterShowData from "../CashRegisterShow/CashRegisterShowData";

export default {
  name: "CashRegisterDelete",
  components: {CashRegisterShowData, CrudDelete},
  props:{
    open: {type: Boolean, default: true},
    item: {type: Object, required: true}
  },
  data() {
    return {
      title: 'delivery.cashRegister.deleting',
      errorMessage: '',
      loading: false
    }
  },
  methods: {
    remove() {
      this.loading = true
      CashRegisterProvider.deleteCashRegister(this.item.id).then(result => {
            if (result.data.deleteCashRegister.success) {
              this.$emit('itemDeleted', result.data.deleteCashRegister)
              this.$emit('close')
            }
          }
      ).catch(error => {
        let clientError = new ClientError(error)
        this.errorMessage = clientError.i18nMessage
      }).finally(() => this.loading = false)
    }
  },
}
</script>
